const fullName = document.getElementById("fullName");
const phoneNumber = document.getElementById("phoneNumber");
const region = document.getElementById("region__select");
const button = document.querySelector(".submit__button");
const message = document.getElementById("goal");
const businessFormWrapper = document.querySelector(
  ".for_business-form-wrapper"
);
const successMessage = document.querySelector(".success__modal");
const backBtn = document.querySelector(".back_btn");

backBtn.addEventListener("click", () => {
  window.history.back();
});

const requiredInputs = [
  { element: fullName, minLength: 1 },
  { element: message, minLength: 1 },
  { element: phoneNumber, minLength: 13, maxLength: 13 },
];

requiredInputs.forEach((input) => {
  input.element.addEventListener("input", () => {
    input.element.classList.remove("invalid");
  });
});

const validation = () => {
  requiredInputs.forEach((input) => {
    if (input.element.value < input.minLength) {
      input.element.classList.add("invalid");
    }
  });

  if (phoneNumber.value.length !== 13) {
    phoneNumber.classList.add("invalid");
  }

  const hasErrorOnValidation = requiredInputs.some((input) =>
    input.element.classList.contains("invalid")
  );

  if (hasErrorOnValidation) {
    return true;
  }

  return false;
};

console.log(regions);

function capitalizeString(str) {
  return str.toLowerCase().charAt(0).toUpperCase() + str.slice(1);
}

const getLocationById = (regionId) => {
  let selectedRegion = regions.find((region) => region.REGION == regionId);

  if (selectedRegion) {
    return capitalizeString(selectedRegion.REGION_NAME);
  }

  return null;
};

const sendRequest = async () => {
  let selectedRegion = getLocationById(region.value);
  const body = {
    name: fullName.value,
    phone: phoneNumber.value,
    region: selectedRegion,
    message: message.value,
  };

  console.log(selectedRegion);

  const config = {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  const url = `${window.origin}/apps/macbro/macbro/business-form`;

  const res = await fetch(url, config);

  if (res.ok) {
    businessFormWrapper.style.display = "none";
    successMessage.style.display = "flex";
  }
};

button.addEventListener("click", () => {
  const hasErrorOnValidation = validation();
  if (!hasErrorOnValidation) {
    sendRequest();
  }
});
